import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  CssBaseline,
  Autocomplete,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AppBarComponent from "../../components/layout/AppbarComponent";
import units from "../../utils/units";
import { ToastContainer, toast } from "react-toastify";
import api from "../../api/axiosInstance"


// const API_URL = process.env.REACT_APP_API_URL;

const FormRow = ({ label, children }) => (
  <Box
    sx={{
      backgroundColor: "#fff",
      borderRadius: 2,
      p: 2,
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { xs: "flex-start", sm: "center" },
      gap: 2,
    }}
  >
    <Typography
      sx={{
        width: { xs: "100%", sm: 180 },
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {label}
    </Typography>
    {children}
  </Box>
);

const AddSoftware = () => {
  const navigate = useNavigate();
  const [autoIdFailed, setAutoIdFailed] = useState(false);

  const [formData, setFormData] = useState({
    software_id: "",
    software_name: "",
    owner: "",
  });
  // console.log("formData : ", formData);

  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const fetchSoftwareId = async () => {
      try {
        const response = await api.get("api/software/generateSoftwareID");
        const data = response.data;

        setFormData((prev) => ({ ...prev, software_id: data.software_id }));
        setAutoIdFailed(false);
      } catch (error) {
        console.error("Error fetching software ID:", error);
        setAutoIdFailed(false);
      }
    };

    fetchSoftwareId();
  }, []);

  const handleSubmit = async () => {
  if (!formData.software_id || !formData.software_name || !formData.owner) {
    toast.error("กรุณากรอกข้อมูลให้ครบทุกช่อง");
    return;
  }

  setLoading(true);
  try {
    await api.post("api/software/addsoftware", formData);

    toast.success("บันทึกข้อมูลเรียบร้อยแล้ว", {
      onClose: () => navigate("/home"),
    });
  } catch (error) {
    console.log("STATUS:", error.response?.status);
    console.log("DATA:", error.response?.data);
    toast.error(error.response?.data?.error || "ไม่สามารถบันทึกข้อมูลได้");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <CssBaseline />
      <AppBarComponent />
      <ToastContainer position="top-center" autoClose={2000} />
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "rgba(128, 189, 182, 0.71)",
          p: { xs: 2, sm: 5 },
        }}
      >
        <Typography variant="h5" fontWeight="bold" mb={4} textAlign="center">
          เพิ่มข้อมูลซอฟต์แวร์
        </Typography>

        <Box
          sx={{
            maxWidth: 600,
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* Software ID */}
          <FormRow label="Software ID">
            <TextField
              fullWidth
              size="small"
              sx={{ backgroundColor: "#D9D9D9" }}
              value={formData.software_id}
              disabled={!autoIdFailed}
              onChange={(e) => handleChange("software_id", e.target.value)}
              placeholder={autoIdFailed ? "กรอกด้วยตนเอง" : ""}
            />
          </FormRow>
          {/* Software Name */}
          <FormRow label="ชื่อซอฟต์แวร์">
            <TextField
              fullWidth
              size="small"
              sx={{ backgroundColor: "#D9D9D9" }}
              value={formData.software_name}
              onChange={(e) => handleChange("software_name", e.target.value)}
            />
          </FormRow>
          {/* Owner */}
          <FormRow label="เจ้าของ">
            <Autocomplete
              fullWidth
              freeSolo
              options={units}
              value={formData.owner}
              inputValue={formData.owner}
              onInputChange={(e, value) => handleChange("owner", value)}
              onChange={(e, value) => handleChange("owner", value || "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "#D9D9D9" }}
                />
              )}
            />
          </FormRow>

          {/* Submit button */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ minWidth: 120 }}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "กำลังบันทึก..." : "บันทึก"}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AddSoftware;
